<template>
<div  class="flex flex-col">

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 4 of 6
  </p> -->

  <label
    for="location"
    class="flex flex-col justify-end text-xl text-gray-700 font-medium sm:text-2xl"
  >
    What is your budget?
  </label>
  <p class="mt-2 text-sm text-gray-500">
    Per hour in <span class="font-bold" title="GBP - Great British Pound" style="cursor: help">£</span>
  </p>

  <MultiRangeSlider
    :min="1"
    :max="100"
    :step="5"
    :minValue="minRate"
    :maxValue="maxRate"
    :ruler="false"
    :label="false"
    @input="updateRate"
    class="mt-6"
  />

  <div class="flex justify-between">
    <div class="relative">
      <input
        inputmode="numeric"
        :value="minRate"
        @input="onMinRateInput"
        class="py-3 pl-4 pr-2 w-20 rounded-md text-base text-center uppercase placeholder-gray-500 border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
      />
      <span class="absolute top-1/2 left-3 -mt-3 text-gray-400 font-semibold pointer-events-none">
        £
      </span>
    </div>

    <div class="relative">
      <input
        inputmode="numeric"
        :value="maxRateLabel"
        @input="onMaxRateInput"
        class="py-3 pl-4 pr-2 w-20 rounded-md text-base text-center uppercase placeholder-gray-500 border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
      />
      <span class="absolute top-1/2 left-3 -mt-3 text-gray-400 font-semibold pointer-events-none">
        £
      </span>
    </div>
  </div>

  <button type="button" @click="nextStep" class="mt-6 self-start inline-flex items-center gap-x-2.5 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
    Next
    <svg class="-mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
      <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" fill="currentColor" />
    </svg>
  </button>

</div>
</template>
<script>

import MultiRangeSlider from 'multi-range-slider-vue'

export default {
  components: {
    MultiRangeSlider,
  },
  props: {
    enquiry: Object,
  },
  data() {
    return {
      minRate: 1,
      maxRate: 100,
    }
  },
  computed: {
    maxRateLabel() {
      return this.maxRate === 100 ? '99+' : this.maxRate
    }
  },
  methods: {
    updateRate(e) {
      this.minRate = e.minValue
      this.maxRate = e.maxValue
    },
    nextStep() {
      this.$emit('updateEnquiry', { minRate: this.minRate, maxRate: this.maxRate })
      this.$router.push({ name: 'FindATutor-Message' })
    },
    onMinRateInput(event) {
      const r = parseInt(event.target.value)
      if (isNaN(r)) return
      this.minRate = r
    },
    onMaxRateInput(event) {
      const r = parseInt(event.target.value)
      if (isNaN(r)) return
      this.maxRate = r
    },
  },
  created() {
    if (this.enquiry.minRate) this.minRate = this.enquiry.minRate
    if (this.enquiry.maxRate) this.maxRate = this.enquiry.maxRate  
  }
}
</script>
<style lang="scss">

.multi-range-slider {
  border: none;
  border-radius: 0;
  box-shadow: none;

  .bar-left,
  .bar-inner,
  .bar-right {
    box-shadow: none;
    border: none;
  }

  .bar-inner {
    background-color: rgb(96, 165, 250); // -blue-600
  }

  .thumb::before {
    box-shadow: none;
    border: none;
    width: 22px;
    height: 22px;
    background-color: rgb(30, 64, 175);
  }

  .caption {
    display: none !important;
  }
}

</style>